import React, { useEffect, useState, useMemo } from "react";
import { Constants } from "@eagerdog/constants";
import { IScore, ScentDogGamesScoreDto } from "@eagerdog/interfaces";

import Dropdown, { IOption } from "src/components/Dropdown/Dropdown";
import Input from "src/components/Input/Input";
import StopWatch from "../StopWatch/StopWatch";

import "./ScentDogGamesResults.scss";

interface IProps {
  result: IScore;
  onChange(result: ScentDogGamesScoreDto): void;
}

const ScentDogGamesResults: React.FC<IProps> = (props) => {
  const [loaded, setLoaded] = useState<boolean>(false);
  const [hasChanged, setHasChanged] = useState<boolean>(false);

  const [result, setResult] = useState<IOption>({ id: Constants.score_result_type.qualified, value: "Qualified" });
  const [faultCount, setFaultCount] = useState<number>(0);
  const [time, setTime] = useState<string>("");

  const resultOptions: IOption[] = useMemo(() => [
    { id: Constants.score_result_type.qualified, value: "Qualified" },
    { id: Constants.score_result_type.not_qualified, value: "Not Qualified" },
    { id: Constants.score_result_type.absent, value: "Absent" },
  ], []);

  useEffect(() => {
    if (!loaded) {
      if (props.result?.scent_dog_games) {
        const sdg = props.result.scent_dog_games;

        for (const ro of resultOptions) {
          if (ro.id === sdg.result_type) {
            setResult(ro);
            break;
          }
        }

        setFaultCount(sdg.fault_count ?? 0);
        setTime(sdg.search_time ?? "");
      }

      setLoaded(true);
    }
  }, [loaded, props.result, resultOptions]);

  useEffect(() => {
    if (hasChanged) {
      props.onChange({
        result_type: result.id,
        fault_count: faultCount,
        search_time: result.id === Constants.score_result_type.qualified ? time : undefined,
      });

      setHasChanged(false);
    }
  }, [hasChanged, result, faultCount, time, props]);

  return (
    <div className="ScentDogGamesResults">
      <Dropdown
        value={result}
        label="Result"
        onChange={(_e: any, value: IOption) => {
          setResult(value);
          setHasChanged(true);
        }}
        options={resultOptions}
        placeholder=""
      />
      {result.id === Constants.score_result_type.qualified && (
        <StopWatch
          time={time}
          onChange={(value: string) => {
            setTime(value);
            setHasChanged(true);
          }}
        />
      )}
      <div className="faults-section">
        <Input
          label="Number of Faults"
          id="fault_count"
          type="number"
          min={0}
          defaultValue={faultCount.toString()}
          onChange={(e) => {
            e.stopPropagation();
            const val = parseInt(e.target.value);
            setFaultCount(isNaN(val) ? 0 : val);
            setHasChanged(true);
          }}
        />
      </div>
    </div>
  );
};

export default ScentDogGamesResults;
